import axios from 'axios';

const RESTRICTED_REGION_CAUSE = 'restricted_region';
export const RESTRICTED_REGION_MESSAGE = 'Den is not supported in your region.';

const RESTRICTED_REGION_EVENT_NAME = 'den:restricted-region-detected';

type ApiErrorResponse = {
  error?: {
    body?: {
      cause?: unknown;
      message?: unknown;
    };
  };
};

/**
 * Checks whether an API error payload matches the backend's restricted-region envelope.
 */
export function isRestrictedRegionResponse(data: unknown): boolean {
  const body = (data as ApiErrorResponse | undefined)?.error?.body;
  return body?.cause === RESTRICTED_REGION_CAUSE;
}

/**
 * Runtime-safe guard for restricted-region Axios failures.
 */
export function isRestrictedRegionError(error: unknown): boolean {
  return (
    axios.isAxiosError(error) &&
    isRestrictedRegionResponse(error.response?.data)
  );
}

/**
 * Broadcasts a restricted-region detection so the app can swap to the blocked screen.
 */
export function notifyRestrictedRegionDetected(): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new Event(RESTRICTED_REGION_EVENT_NAME));
}

/**
 * Subscribes to cross-app restricted-region detections and returns an unsubscribe callback.
 */
export function subscribeToRestrictedRegionDetected(
  handler: () => void
): () => void {
  if (typeof window === 'undefined') {
    return () => {};
  }

  window.addEventListener(RESTRICTED_REGION_EVENT_NAME, handler);
  return () => {
    window.removeEventListener(RESTRICTED_REGION_EVENT_NAME, handler);
  };
}
